<template>
  <div>
    <div>
      <p class="bold">חלון מספר 2 מתוך 3</p>
    </div>
    <div>
      <p style="font-size: 30px;"><b>{{payload.history_company.name}}</b></p>
      <div>
        <p><b>Contact Name</b></p>
        <input v-model="contact_name" class="outlined full_width">
      </div>
      <div>
        <p><b>Phone Number</b></p>
        <input v-model="phone_number" class="outlined full_width">
      </div>
      <div class="my-3">
        <ContactEmail
          v-model="contact_email"
          :companyId="payload.history_company.id"
          :isDryRun="true"
        />
      </div>
      <div>
        <p><b>Owner</b></p>
        <input v-model="owner" class="outlined full_width">
      </div>
      <div>
        <p><b>ספר טלפונים</b></p>
        <textarea v-model="phone_book" class="outlined full_width" rows="4" placeholder="הזן מספרי טלפון נוספים..."></textarea>
      </div>
      <div>
        <p><b>Status</b></p>
        <select v-model="status" dir="rtl">
          <option>active</option>
          <option>blocked</option>
          <option>pending</option>
          <option>test</option>
        </select>
      </div>
      <div>
        <p><b>מצב שליחת קורות חיים דפולטיבי</b></p>
        <select v-model="default_cv_sending_mode" dir="rtl">
          <option value="normal">רגיל (Normal)</option>
          <option value="lite">לייט (Lite)</option>
          <option value="super_lite">סופר לייט (Super Lite)</option>
        </select>
      </div>
    </div>
    <div class="vertical_space"></div>
    <div class="vertical_space"></div>
    <div class="modal_footer">
      <a
        @click="submit()"
        :class="{ 'is-loading': is_loading }"
        class="button is-info"
        >המשך לשלב הבא</a
      >
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import Validator from '@/custom/classes/validator.js'
import ContactEmail from './entities/company/ContactEmail.vue'

export default {
  name: 'create-company-step-two',
  components: {
    ContactEmail
  },
  props: ['payload'],
  data () {
    return {
      validator: new Validator(),
      is_loading: false,
      phone_number: '',
      contact_name: '',
      contact_job_description: '',
      contact_email: '',
      status: 'active',
      message: '',
      owner: this.$utils.getOwner().name,
      phone_book: '',
      default_cv_sending_mode: 'normal'
    }
  },
  methods: {
    async submit () {
      try {
        if (!this.validator.validateEmail({ value: this.contact_email })) {
          this.$utils.emit('show_toast', { text: 'אימייל איש קשר לא תקין' })
          return
        }
        this.is_loading = true

        // Check if history company is already linked to another company
        try {
          const existingCompanies = await this.$network_utils.getCompaniesByHistoryCompany({ history_company_id: this.payload.history_company.id })
          if (existingCompanies && existingCompanies.length > 0) {
            this.is_loading = false
            this.$utils.emit('show_toast', { text: `החברה ${this.payload.history_company.name} כבר קיימת במערכת` })
            return
          }
        } catch (checkError) {
          // Continue if check fails - might be a new history company
          console.log('History company check failed:', checkError)
        }

        // Generate a more unique email for the user
        const timestamp = Date.now()
        const randomSuffix = Math.floor(Math.random() * 100000)
        const randomEmail = `company_${this.payload.history_company.id}_${timestamp}_${randomSuffix}@temp.local`

        const responce = await this.$network_utils.postUser({
          name: this.payload.history_company.name,
          first_name: this.contact_name,
          password: this.$utils.getRandomString({ length: 6 }),
          resource_type: 'Company',
          phone_number: this.phone_number,
          email: randomEmail,
          contact_email: this.contact_email,
          owner: this.owner,
          status: this.status,
          history_company_id: this.payload.history_company.id
        })
        await this.$network_utils.updateCompany({
          id: responce.resource_id,
          contact_email: this.contact_email,
          phone_book: this.phone_book,
          default_cv_sending_mode: this.default_cv_sending_mode
        })
        const h = await this.$network_utils.linkCompanyHistoryCompany({ history_company_id: this.payload.history_company.id, current_company_id: responce.resource_id })
        // Pass the company resource_id from the original user creation response, not from linkCompanyHistoryCompany
        this.continueToStepThree({
          current_resource_id: responce.resource_id,
          resource: {
            company: {
              id: responce.resource_id,
              name: this.payload.history_company.name,
              ...((h.resource && h.resource.company) || {})
            }
          }
        })
      } catch (e) {
        this.is_loading = false
        console.error('Company creation error:', e)

        // Provide more specific error messages
        let errorMessage = 'ארעה שגיאה ביצירת החברה'

        if (e.response && e.response.data) {
          if (e.response.data.message) {
            errorMessage = e.response.data.message
          } else if (e.response.data.errors) {
            if (e.response.data.errors.email) {
              errorMessage = 'כתובת האימייל כבר קיימת במערכת'
            } else if (e.response.data.errors.name) {
              errorMessage = 'שם החברה כבר קיים במערכת'
            } else if (e.response.data.errors.history_company_id) {
              errorMessage = 'החברה כבר מקושרת לחברה אחרת במערכת'
            } else {
              errorMessage = Object.values(e.response.data.errors).flat().join(', ')
            }
          }
        } else if (e.message) {
          errorMessage = e.message
        }

        this.$utils.emit('show_toast', { text: errorMessage })
      }
    },
    async continueToStepThree (response) {
      try {
        // Call validate_resource event
        await this.$network_utils.postEvent({
          resource_id: response.current_resource_id,
          resource_type: 'Company',
          current_type: 'Company',
          event: 'validate_resource'
        })

        // Proceed to step three
        this.create({
          desginator: 'create-company-step-three',
          component_name: 'CreateCompanyStepThree',
          ignore_escape_button: true,
          company: response.resource.company,
          modal_title: 'Create new Company'
        })
        this.payload.is_fixed = false
        this.remove(this.payload)
      } catch (error) {
        console.error('Error in continueToStepThree:', error)
        let errorMessage = 'שגיאה במעבר לשלב הבא'

        if (error.response && error.response.data && error.response.data.message) {
          errorMessage = error.response.data.message
        } else if (error.message) {
          errorMessage = error.message
        }

        this.$utils.emit('show_toast', { text: errorMessage })
      }
    },
    ...mapMutations('modals', ['remove', 'create'])
  }
}
</script>
